import React from "react";
import TaxAndCommissions from "../modules/TaxAndCommissions";

export default function TaxAndCommissionsPage() {
    return <TaxAndCommissions/>
}